<template>
  <ul class="pro-flex-list">
    <template v-if="nums == -1">
      <li class="pro"  v-for="(item,index) in handleData"
      :key="index"  :class="item.image ? 'active' + ' ' + row : 'not' + ' ' + row "
    >
      <template v-if="item.image">
        <a href="javascript:;"  @click="itemClick(item)">
          <div class="pro-img">
            <img v-lazy="item.image" :alt="item.name" :key="item.image_url">
          </div>
          <div class="title">{{item.name}}</div>
        </a>
      </template>
    </li>
    </template>

    <!-- <template v-else>
      <li class="pro"  v-for="(item,index) in handleData.slice(0, nums)"
      :key="index"  :class="item.cover_url?'active'+' '+row:'not'+' '+row"
    >
      <template v-if="item.image || item.cover_url">
        <a :href="item.url" >
          <div class="pro-img">
            <img v-lazy="item.image_url || item.cover_url" :alt="item.name" :key="item.image_url">
          </div>
       </a>
      </template>
    </li>
    </template> -->

  </ul>
</template>
<script>
import {linkCommon } from '@/utils/index.js'

import { mapActions } from "vuex";
export default {
  name: "LoftRow",
  components: {},
  props: {
    row: {
      type: String,
      default: ""
    },
    list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    
    nums: {
      type: [Number, String],
      default: -1
    }
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    handleData() {
      // let data = this.list;
      // data.forEach(() => {
      //   let list = data.length;
      //   let num = list % 4;
      //   if (num !== 0) {
      //     for (let i = 0; i < 4 - num; i++) {
      //       data.push({});
      //     }
      //   }
      // });
      return this.list;
    }
  },
  methods: {
    ...mapActions(["getCartNumsAction"]),

    itemClick(v) {
      linkCommon(v, this)
    },
    //切换收藏
    changeFav(id, index) {
      let data = {
        goods_id: id
      };
      this.$api.goodsCollection(data).then(res => {
        if (res.status) {
          this.$msg(res.msg);
        }
      });
    },
    addToCart(id) {
      let data = {
        product_id: id,
        nums: 1
      };
      this.$api.addCart(data).then(res => {
        if (res.status) {
          this.$notify({
            title: this.$t('success'),
            type: "success",
            offset: 100,
            duration:2500,
            dangerouslyUseHTMLString: true,
            message: `<a href="/cart" style="background:#FF7159;color:#FFF;font-size:12px;padding:5px 22px;">${this.$t('toPay')}</a>`
          });
          this.getCartNums();
        }
      });
    },
    // 获取购物车数量
    getCartNums() {
      this.$api.getCartNum().then(res => {
        if (res.status) {
          this.getCartNumsAction(res.data);
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.pro-flex-list {
  display: flex;
  flex-flow: row wrap;
  // justify-content: space-between;
  // overflow: hidden;
  .pro {
    position: relative;
    // width: 234px;
    width: 19%;
    height: 300px;
    margin-bottom: 14px;
    padding: 5px;
    background: #fff;
    transition: all 0.25s linear;
    box-sizing: border-box;
    margin-right: 13px;
    &:nth-child(4n) {
      margin-right: 0;
    }
    &:nth-last-child(-n + 4) {
      margin-bottom: 0;
    }
    &.row-4 {
      width: 24%;
    }
    &.not {
      background: $theme-bg;
    }
    &.active:hover {
      transform: translateY(-3px);
      box-shadow: 1px 1px 20px #999;
      .pro-handle-icon {
        display: block;
      }
    }
    a {
      display: block;
      width: 100%;
      height: 100%;
      position: relative;
      .pro-img {
        width: 225px;
        height: 290px;
        margin: 0 auto 10px;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .title {
        margin: 0 10px;
        font-size: 13px;
        line-height: 22px;
        font-weight: 400;
        color:#666;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 限定几行文字溢出 */
        overflow: hidden;
        text-align: left;
        height: 40px;

      }
      .desc {
        margin: 0 10px 10px;
        height: 18px;
        font-size: 12px;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        color: #b0b0b0;
      }
      .price {
        text-align: center;
        color: $price;
        position: absolute;
        bottom: 20px;
        left: 0;
        width: 100%;
      }
    }
  }
}
//产品收藏添加购物车
.pro-handle-icon {
  display: none;
  position: absolute;
  height: 24px;
  top: 14px;
  cursor: pointer;
  padding: 3px 4px;
  span {
    font-size: 12px;
    opacity: 0;
    transition: opacity 0.2s linear;
    color: $theme-color;
  }
  &:hover {
    span {
      opacity: 1;
      font-weight: 550;
    }
    // .icon {
    //   color: $theme-color;
    // }
  }
  .icon {
    font-size: 18px;
    vertical-align: -1px;
    margin-right: 3px;
    color: $theme-color;
    // color:#FFF;
  }
  &.pro-collet-icon {
    left: 10px;
  }
  &.pro-addcart-icon {
    right: 10px;
  }
}
</style>